import type { HotelBooking, Price } from "@/features/hotels/types/types";
import { DEFAULT_CURRENCY } from "@/utils/currency";

export const calculateBookingPrice = (booking: HotelBooking): Price => {
  return {
    value:
      booking.rooms.reduce((acc, room) => acc + (room.price?.value || 0), 0) ||
      0,
    currency:
      booking.rooms.length > 0 && booking.rooms[0].price?.currency
        ? booking.rooms[0].price?.currency
        : DEFAULT_CURRENCY,
  };
};
